import { ReactNode } from "react";

import { css } from "@compiled/react";

import { wacToken } from "@/libraries/design/foundations";

export const FormWithPaymentOverlay = ({
    children,
    paymentDetailsPage
}: {
    children: ReactNode;
    paymentDetailsPage?: ReactNode;
}) => {
    const overlayContent = paymentDetailsPage ?? null;

    return (
        <div css={wrapperCss}>
            {children}
            {overlayContent && <div css={overlayCss}>{overlayContent}</div>}
        </div>
    );
};

const wrapperCss = css({
    position: "relative"
});

const overlayCss = css({
    position: "absolute",
    inset: 0,
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: wacToken("color.neutral.light0")
});
